import {
  Database,
  ShieldAlert,
  FileText,
  Handshake,
  Inbox,
  AlertTriangle,
  ListChecks,
  Globe2,
  CheckCircle2,
} from "lucide-react";
import { Container } from "@/components/ui/container";
import { SectionHeading } from "@/components/ui/section-heading";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { capabilities } from "@/lib/content";

const icons = [Globe2, Database, ShieldAlert, FileText, Handshake, Inbox, AlertTriangle, CheckCircle2, ListChecks];

export function Capabilities() {
  return (
    <section id="capabilities" aria-labelledby="capabilities-heading" className="py-16 sm:py-24">
      <Container>
        <SectionHeading
          titleId="capabilities-heading"
          eyebrow="Launch product"
          title="One workspace for the privacy work small businesses actually need to run."
          description="These are committed launch modules. Until the authenticated product is released, they are product scope — not a claim that every workflow is already available today."
        />

        <div className="mt-12 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {capabilities.map((capability, index) => {
            const Icon = icons[index % icons.length] ?? Database;
            return (
              <Card key={capability.title} className="h-full min-w-0">
                <CardHeader>
                  <div className="mb-2 flex items-start justify-between gap-3">
                    <span
                      aria-hidden="true"
                      className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-accent text-accent-foreground"
                    >
                      <Icon className="h-5 w-5" />
                    </span>
                    <Badge variant="outline">{capability.status}</Badge>
                  </div>
                  <CardTitle>{capability.title}</CardTitle>
                </CardHeader>
                <CardContent className="pt-0">
                  <p className="text-sm leading-relaxed text-muted-foreground">
                    {capability.body}
                  </p>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </Container>
    </section>
  );
}
